<template>
  <div class="section-main bg-white">
    <section class="section-services">
      <div class="items-center">
        <p class="section_heading mb-5">Services</p>
        <h3 class="section__h3 mb-base">How can we help you?</h3>
        <vs-row
          class="services-row container items-center"
          vs-type="flex"
          vs-justify="space-between"
        >
        <div class="sm:w-full lg:w-8/10 hidden-below-lg">
        <hr class="line">
        
          <img class="cirin inactive1" src="@/assets/images/aboutUs/Ellipse 4.svg" alt="">
          <img class="cirin inactive2" src="@/assets/images/aboutUs/Ellipse 4.svg" alt="">
          <img class="cirin inactive3" src="@/assets/images/aboutUs/Ellipse 4.svg" alt="">

          <img class="circ circle1" src="@/assets/images/aboutUs/circle.png" alt="">
          <img class="circ circle2" src="@/assets/images/aboutUs/circle.png" alt="">
          <img class="circ circle3" src="@/assets/images/aboutUs/circle.png" alt="">
          <img class="diam" src="@/assets/images/aboutUs/green-diam.png" alt="">
        </div>
          <vx-card class="services-card info no-shadow p-5">
            <div class="services-content text-left">
              <h6 class="services-title-left mb-3">Infographic resumes</h6>
              <span class="services-description"
                >A repository of your branding assets with Briefcase and self
                devlopment guide with YouLab to manage BrandYou</span
              >
            </div>
          </vx-card>
          <vx-card class="services-card career no-shadow left p-5">
            <!--<div class="mt-3 mb-1" slot="media">
              <span
                class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
              >
                <img src="" alt="" width="40px" height="40px" />
              </span>
            </div>-->
            <div class="services-content text-center">
              <h6 class="services-title mb-3">Career Guides</h6>
              <span class="services-description"
                >Our team of brand strategists, career coaches and developers
                helps you build your brand online.</span
              >
            </div>
          </vx-card>
          <vx-card class="services-card no-shadow services-card-3 p-5">
            <!--<div class="mt-3 mb-1" slot="media">
                  <span
                    class="p-3 inline-flex rounded-full feather-icon select-none relative text-primary mc-icon"
                    style="background: rgba(var(&#45;&#45;vs-primary),0.15);"
                  >
                    <img src="" alt="" width="40px" height="40px" />
                  </span>
            </div>-->
            <div class="services-content opportunity text-right">
              <h6 class="services-title-right mb-3">Opportunity Matching</h6>
              <span class="services-description"
                >Providing assistance in analyzing organizational branding goals
                with measurement and strategy.</span
              >
            </div>
          </vx-card>
        </vs-row>
      </div>
    </section>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
export default {
  ScrollTrigger,
  name: "Services",

methods: {
  servicesAnimation(){
    ScrollTrigger.matchMedia({
        "(min-width: 1250px)": function () {
          let t2 = gsap.timeline({
            scrollTrigger: {
              trigger: ".section-main",
              scrub: 0.2,
              pin: true,
              start: "top top",
              end: "+200%",
              // markers:true //(for debugging scroll function)
              // invalidateOnRefresh: true
            },
          });
          
              t2.from(".circle2", { opacity:0, duration: 2 }, "a");
              t2.to(".circle1", { opacity:0, duration: 1 }, "a");
              t2.from(".career", { opacity:0.4, duration: 1, }, "a");
              t2.to(".diam", { xPercent:800, duration: 2, ease: 'power1.out' }, "a");
              t2.to(".info", { opacity:0.4, duration: 2, ease: 'power1.out' }, "a");

              t2.from(".circle3", { opacity:0, duration: 2, delay:4 }, "a");
              t2.to(".circle2", { opacity:0, duration: 1, delay:4 }, "a");
              t2.from(".opportunity", { opacity:0.4, duration: 1, delay:4 }, "a");
              t2.to(".diam", { xPercent:1670, duration: 2, ease: 'power1.out', delay:4  }, "a");
              t2.to(".career", { opacity:0.4, duration: 2, delay:5, ease: 'power1.out' }, "a");

              t2.to({}, {duration:2});
        }
        
    });

  }
},
  
  mounted (){
    this.servicesAnimation();
},
}
</script>

<style scoped>
.cirin {
  position: absolute;
    z-index: 2;
}
.circ {
 position: absolute;
 z-index: 3;
}
.circle1{
    left: 11%;
    top: 30%;
}
 .circle2 {
    left: 43%;
    top: 30%;
 }
 .circle3 {
   right: 10%;
    top: 30%;
 }
 .inactive1{
    left: 14%;
    top: 38%;
}
 .inactive2 {
    left: 48%;
    top: 38%;
 }
 .inactive3 {
   right: 15%;
    top: 38%;
 }
.diam {
  position: absolute;
    left: 15%;
    z-index: 3;
    top: 36%;
}
.line {
  border-top: 1px dashed orange;
  display: flex;
  width: 85%;
}
.items-center {
  text-align: space-between;
  text-align: -moz-center;
  text-align: -webkit-center;
}
.items-left {
  text-align: left;
  text-align: -moz-left;
  text-align: -webkit-left;
}
section {
  padding: 7rem;
  background: #ffffff;
}
.section-main {
  position: relative;
}

.section__h3 {
  font-style: normal;
  font-weight: bold;
  font-size: 40px;
  line-height: 140%;
  color: #121127;
  text-transform: capitalize;
}
.section__p {
  width: 60%;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  /* or 150% */
  text-align: center;
  color: #848199;
}
/*===============================================*/
/* OUR SERVICES	 						 */
/*===============================================*/

.services-row {
  margin-top: 5rem;
}

.services-card {
  height: 280px;
  width: 340px;
  margin: 0;
}

.services-content {
  padding-top: 5rem !important;
}

.services-content h6 {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 25px;
  text-transform: capitalize;
  color: #121127;
}
.services-title {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #231d4f;
}
.services-description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 180%;
  color: #5d6473;
}
.section_heading {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 170%;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #44cc88;
}
/*===============================================*/
/* MEDIA QUERIES	 						 */
/*===============================================*/

@media (max-width: 1200px) {
  section {
    padding: 2rem 2rem;
    background: #ffffff;
  }
  .section__p {
    width: -webkit-fill-available;
    width: -moz-available;
  }
  .hidden-below-lg {
    display: none;
  }
  .opportunity, .career {
    opacity: 1!important;
    text-align: center!important;
  }
  .text-left {
    text-align: center!important;
  }
  .services-content {
    padding-top: 0!important;
  }
}
</style>
